import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type CardFrontBoardHintFragment = (
  { __typename: 'Board' }
  & Pick<Types.Board, 'id'>
  & { prefs?: Types.Maybe<(
    { __typename: 'Board_Prefs' }
    & Pick<Types.Board_Prefs, 'backgroundColor' | 'backgroundImage'>
    & { backgroundImageScaled?: Types.Maybe<Array<(
      { __typename: 'Board_Prefs_BackgroundImageScaled' }
      & Pick<Types.Board_Prefs_BackgroundImageScaled, 'height' | 'url' | 'width'>
    )>> }
  )> }
);

export const CardFrontBoardHintFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CardFrontBoardHint' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Board' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'prefs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundColor' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundImage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'backgroundImageScaled' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'height' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseCardFrontBoardHintFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      CardFrontBoardHintFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseCardFrontBoardHintFragmentResult
  extends Omit<Apollo.UseFragmentResult<CardFrontBoardHintFragment>, 'data'> {
  data?: CardFrontBoardHintFragment;
}

export const useCardFrontBoardHintFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCardFrontBoardHintFragmentOptions): UseCardFrontBoardHintFragmentResult => {
  const result = Apollo.useFragment<CardFrontBoardHintFragment>({
    ...options,
    fragment: CardFrontBoardHintFragmentDoc,
    fragmentName: 'CardFrontBoardHint',
    from: {
      __typename: 'Board',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CardFrontBoardHintFragment };
};
